import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, ChevronDown, Menu, X } from "lucide-react";
import { ANNOUNCEMENTS, PLANS, planToParams } from "@/data/content";
import Logo from "@/components/Logo";

export default function Navbar() {
  const navigate = useNavigate();
  const [idx, setIdx] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % ANNOUNCEMENTS.length), 4500);
    return () => clearInterval(t);
  }, []);

  const a = ANNOUNCEMENTS[idx];
  const navItems = [
    { label: "Radio", href: "/#radio" },
    { label: "Services", href: "/#plans" },
    { label: "Security", href: "/#antivirus" },
    { label: "Work", href: "/#ways" },
  ];

  return (
    <>
      {/* Announcement bar */}
      <div className="bg-[#3B82F6] text-[#0F172A] text-sm py-2 px-4" data-testid="announcement-bar">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center">
          <span key={idx} style={{ animation: "fadeInUp 0.4s ease" }}>
            <span className="font-bold">{a.strong}</span> {a.text}
          </span>
          <button
            onClick={() => navigate(`/checkout${planToParams(PLANS[0])}`)}
            className="hidden sm:inline-flex items-center gap-1 bg-[#26395F] text-white text-xs font-semibold px-3 py-1 rounded-full hover:bg-black transition-colors"
            data-testid="announcement-cta"
          >
            {a.cta} ›
          </button>
        </div>
      </div>

      {/* Nav */}
      <header className="sticky top-0 z-50 bg-[#26395F] border-b border-white/10" data-testid="navbar">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="brand-logo">
            <Logo />
          </Link>

          <nav className="hidden md:flex items-center gap-8 text-sm text-white/80">
            {navItems.map((n) => (
              <a
                key={n.label}
                href={n.href}
                className="flex items-center gap-1 hover:text-white transition-colors"
                data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]/g, "")}`}
              >
                {n.label} <ChevronDown className="h-3.5 w-3.5 opacity-60" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button className="hidden sm:flex h-9 w-9 items-center justify-center rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors" data-testid="nav-search-btn" aria-label="Search">
              <Search className="h-4 w-4" />
            </button>
            <button
              onClick={() => navigate(`/checkout${planToParams(PLANS[0])}`)}
              className="btn-sweep bg-white text-[#0F172A] font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-[#3B82F6] hover:text-white transition-colors duration-300"
              data-testid="nav-subscribe-btn"
            >
              Get Started
            </button>
            <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {open && (
          <nav className="md:hidden bg-[#26395F] border-t border-white/10 px-6 py-4 flex flex-col gap-4 text-white/80">
            {navItems.map((n) => (
              <a key={n.label} href={n.href} onClick={() => setOpen(false)} className="hover:text-white">{n.label}</a>
            ))}
          </nav>
        )}
      </header>
    </>
  );
}
